module.exports = __webpack_public_path__ + "static/media/badge-ios.72f53cf8.png";